import React from 'react';
import moment from 'moment';

export interface InformationPanelProps {
  acceptedAnytime: boolean;
  offerSubmissions: string;
  shouldShowOfferCount: boolean;
  offerCount: number;
  offerDate: string;
  requestIrrevocable?: number;
  otherInstructions?: string;
}

const InformationPanel: React.FC<InformationPanelProps> = ({
  acceptedAnytime,
  offerSubmissions,
  shouldShowOfferCount,
  offerCount,
  offerDate,
  requestIrrevocable,
  otherInstructions,
}) => (
    <div className="col-md-4 left-panel">
      <div className="hpanel">
        <div className="panel-body">
          <h3>Information</h3>
          {shouldShowOfferCount && (
            <>
              <h4>Offers Registered</h4>
              <p>{offerCount}</p>
            </>
          )}
          <h4>Presentation Date</h4>
          {acceptedAnytime ? (
            <div>
              <p>Offers accepted anytime.</p>
            </div>
          ) : (
            <div>
              <p>{moment(offerDate).format('MMM DD, YYYY h:mm A')}</p>
            </div>
          )}
          {offerSubmissions && (
            <div>
              <span>Offers to be presented by: {offerSubmissions}</span>
            </div>
          )}
          {requestIrrevocable && (
            <div>
              <h4>Request Irrevocable</h4>
              <p>{requestIrrevocable} hours</p>
            </div>
          )}
          {otherInstructions && (
            <div>
              <h4>Other Instructions</h4>
              <p>{otherInstructions}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

export default InformationPanel;
